<div class="container-fluid">
  <div class="row row-gap">
    <div class="row w-100 m-0">
      <div class="row no-gutters col-md-4 pt-4 align-content-start">
        <div class="col-md-12">
          <mat-checkbox
            name="showSeconds"
            class="light rss-checkbox"
            [disableRipple]="true"
            [(ngModel)]="timerConfig.ShowSeconds"
            [disabled]="timerConfig.TimerType !== timerTypes.Clock">
            Show seconds
          </mat-checkbox>
        </div>
      </div>

      <div class="row no-gutters col-md-4 justify-content-between">
        <div class="col-md-12 mb-3 pl-0">
          <h6 class="mb-2">Text color</h6>
          <ng-container color-picker>
            <app-color-picker [(color)]="timerConfig.TextColor" [position]="'left'" [isInputHidden]="true"
              [label]="null" [outputFormat]="'rgba'"></app-color-picker>
          </ng-container>
        </div>

        <div class="col-md-12 pl-0">
          <h6 class="mb-2">Background color</h6>
          <ng-container color-picker>
            <app-color-picker [(color)]="timerConfig.BackgroundColor" [position]="'top'" [isInputHidden]="true"
              [label]="null" [outputFormat]="'rgba'"></app-color-picker>
          </ng-container>
        </div>
      </div>

      <div class="row no-gutters col-md-4 justify-content-between">
        <div class="col-md-12">
          <h6 class="mb-2">Position & Size</h6>
          <div class="monitor" #monitor>
            <div
              #timer
              class="timer"
              [style.background]="timerConfig.BackgroundColor"
              [style.width.%]="timerConfig.Width"
              [style.height.%]="timerConfig.Height"
              cdkDrag
              [cdkDragBoundary]="monitor"
              [cdkDragFreeDragPosition]="timerPixelPosition"
              (cdkDragEnded)="onDragEnd($event)"
              tabindex="0">
                <span
                  #dragHandleCorner
                  cdkDragLockAxis="lockAxis"
                  class="dragHandle"
                  cdkDrag
                  (cdkDragMoved)="onResizeDragMove(dragHandleCorner)">
                </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="footer">
    <div class="col-12 d-flex justify-content-end p-0">
      <button matTooltip="Cancel" mat-raised-button type="button" class="mr-3" (click)="dialogRef.close()">
        Cancel
      </button>
      <button matTooltip="Save Timer configuration" mat-raised-button type="button" (click)="dialogRef.close(timerConfig)">
        Save
      </button>
    </div>
  </div>
</div>
